import type { IBiBarsCardProps } from './IBiBarsCardProps';

/** Картка горизонтальних смуг (прототип v4 G:L1735): заголовок 600, рядки — підпис 100–160px, смуга 10px, кількість IBM Plex Mono 12px. */
export function BiBarsCard({ title, bars, color }: IBiBarsCardProps) {
  return (
    <section className="bi-card" aria-label={title}>
      <div className="bi-card__title">{title}</div>
      <div className="bi-bars">
        {bars.map((b) => (
          <div key={b.label} className="bi-bar">
            <span className="bi-bar__label" title={b.label}>{b.label}</span>
            <span className="bi-bar__track"><span className="bi-bar__fill" style={{ width: `${b.width}%`, background: color }} /></span>
            <span className="bi-bar__count">{b.count}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
